import { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@/ui';
import { matchComunas } from './comunas';

// The "Comuna · Región" field: free text with a menu of the catalog's
// communes, and the recent ones when it is empty. It marks itself as a form
// control so an InputRow labels it and points its error at it.
export default function ComunaCombo({
  value,
  onChange,
  recent = [],
  error = false,
  ...aria
}) {
  const [open, setOpen] = useState(false);
  const showingRecent = !value.trim();
  const options = showingRecent ? recent : matchComunas(value);
  return (
    <div className="ndf-combo">
      <Input
        {...aria}
        autoComplete="off"
        placeholder="Comuna · Región"
        value={value}
        error={error}
        onChange={(e) => {
          onChange(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 120)}
      />
      {open && options.length > 0 && (
        <div className="ndf-menu">
          {showingRecent && <div className="ndf-menu-head">Últimas usadas</div>}
          {options.map((o) => (
            <button
              type="button"
              className="ndf-opt"
              key={`${o.comuna}-${o.region}`}
              onMouseDown={(e) => {
                e.preventDefault();
                onChange(`${o.comuna} · ${o.region}`);
                setOpen(false);
              }}
            >
              <b>{o.comuna}</b>
              <span className="ndf-opt-reg">{o.region}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

ComunaCombo.formControl = true;

ComunaCombo.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  recent: PropTypes.arrayOf(
    PropTypes.shape({ comuna: PropTypes.string, region: PropTypes.string }),
  ),
  error: PropTypes.bool,
};
